import React from 'react';
import Modal from '@/components/layout/Modal';
import styles from './PromptDiffViewer.module.css';
import { SugestaoDiff, RegrasSnapshot, buildAnnotatedLines } from './PromptDiffViewer';

type Props = {
    show: boolean;
    onClose: () => void;
    regrasSnapshot: RegrasSnapshot;
    sugestoes: SugestaoDiff[];
    selected: Set<number>;
    onAplicar: () => void;
    applyLoading?: boolean;
    applyDone?: boolean;
};

const ModalPromptPreview = ({ show, onClose, regrasSnapshot, sugestoes, selected, onAplicar, applyLoading, applyDone }: Props) => (
    <Modal
        show={show}
        title="Preview do prompt ajustado"
        size="lg"
        onClose={onClose}
        onCancel={onClose}
        onConfirm={onAplicar}
        cancelProps={{ label: 'Fechar', variant: 'outline-secondary' }}
        confirmProps={{
            label: applyLoading ? 'Aplicando...' : applyDone ? '✓ Aplicado' : 'Aplicar no agente',
            variant: applyDone ? 'success' : 'primary',
            disabled: applyLoading || applyDone,
        }}
    >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {(['pode_fazer', 'nao_pode_fazer'] as const).map((campo) => {
                const fieldText = regrasSnapshot[campo];
                if (!fieldText) return null;
                const annotated = buildAnnotatedLines(fieldText, sugestoes, selected, campo);
                const label = campo === 'pode_fazer' ? 'O que pode fazer' : 'O que não pode fazer';
                return (
                    <div key={campo}>
                        <div className={styles.fullPromptLabel}>{label}</div>
                        <div className={styles.diffLines}>
                            {annotated.map((line, idx) => (
                                <div
                                    key={idx}
                                    className={
                                        line.type === 'removed'
                                            ? styles.diffLineRemoved
                                            : line.type === 'added'
                                                ? styles.diffLineAdded
                                                : styles.diffLineContext
                                    }
                                >
                                    <span className={styles.diffLineSymbol}>
                                        {line.type === 'removed' ? '−' : line.type === 'added' ? '+' : ' '}
                                    </span>
                                    <span className={styles.diffLineText}>{line.text}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                );
            })}
        </div>
    </Modal>
);

export default ModalPromptPreview;
